/* eslint-disable no-param-reassign */
//
// removeNullObjectProperties
//
import removeNullArrayEntries from './removeNullArrayEntries';

const removeNullObjectProperties = (obj, removeUndefined = false) => {
  if (Array.isArray(obj)) {
    removeNullArrayEntries(obj);
    obj.forEach((item) => {
      removeNullObjectProperties(item, removeUndefined);
    });
  } else {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object') {
        // console.log(`inspect obj[${key}]`);
        removeNullObjectProperties(obj[key], removeUndefined);
      } else if ((obj[key] === null)
                || (removeUndefined && (obj[key] === undefined))) {
        // console.log(`Delete obj[${key}]`);
        delete obj[key];
      }
    });
  }

  return obj;
};

export default removeNullObjectProperties;
